import { Button, Flex, Image, Typography } from "antd";
import styled from "styled-components";

const { Title, Text, Paragraph } = Typography;

export const PageWrapper = styled(Flex)`
  && {
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(134deg, #ffffff 1%, #f4f6f9 100%);
    font-family: "Roboto", sans-serif;
    padding: 48px 20px 64px;
    box-sizing: border-box;
  }

  @media (min-width: 992px) {
    && {
      height: 100vh;
      overflow-y: auto;
    }
  }

  @media (max-width: 575px) {
    && {
      padding: 28px 16px 48px;
    }
  }
`;

export const ContentCard = styled(Flex)`
  width: 100%;
  max-width: 820px;
  margin: 0 auto;
`;

export const TopBar = styled(Flex)`
  && {
    width: 100%;
    margin-bottom: 28px;
  }
`;

export const BackButton = styled(Button)`
  && {
    width: 28px;
    height: 28px;
    min-width: 0;
    padding: 0;
    border: none;
    background: transparent;
    color: #28323e;
    box-shadow: none;
    outline: none;
    transition: none;
    flex-shrink: 0;
    margin: 12px 0 20px;

    &:hover,
    &:focus,
    &:focus-visible,
    &:active {
      background: transparent !important;
      color: #28323e !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    &::after {
      display: none !important;
    }

    .anticon {
      font-size: 20px;
    }
  }
`;

export const BrandImage = styled(Image)`
  height: 40px;
  width: auto;

  @media (max-width: 575px) {
    height: 32px;
  }
`;

export const HeaderBlock = styled(Flex)`
  width: 100%;
  margin-bottom: 32px;
`;

export const SectionBlock = styled(Flex)`
  width: 100%;
`;

export const PageTitle = styled(Title)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 36px !important;
    font-weight: 700 !important;
    line-height: 48px !important;
    color: #28323e !important;
    margin: 0 0 8px !important;
  }

  @media (max-width: 575px) {
    && {
      font-size: 28px !important;
      line-height: 36px !important;
    }
  }
`;

export const Subtitle = styled(Text)`
  && {
    display: block;
    font-family: "Roboto", sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 22px;
    color: rgba(40, 50, 62, 0.85);
    margin-bottom: 6px;
  }
`;

export const UpdatedText = styled(Text)`
  && {
    display: block;
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 19px;
    color: rgba(40, 50, 62, 0.6);
  }
`;

export const SectionHeading = styled(Title)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 22px !important;
    font-weight: 700 !important;
    line-height: 30px !important;
    color: #28323e !important;
    margin: 32px 0 12px !important;
  }
`;

export const SubSectionHeading = styled(Title)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 24px !important;
    color: #28323e !important;
    margin: 18px 0 8px !important;
  }
`;

export const SectionParagraph = styled(Paragraph)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(40, 50, 62, 0.78);
    margin-bottom: 12px;
  }
`;
